
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import parse from "html-react-parser";
import type { GetStaticProps, NextPage } from "next/types";
import { PAGE } from "../consts/ppages";
import { getPageById } from "../utils/get-page";
interface IPage {
    page: {
        title: string;
        content: string;
    };
}
const Partners: NextPage<IPage> = ({ page }) => (<>
    <NextSeo languageAlternates={[
        { href: "https://knsokna.pl/partners", hrefLang: "x-default" },
        { href: "https://knswindows.com/partners", hrefLang: "en" },
        { href: "https://knsokna.pl/partners", hrefLang: "pl" },
        { href: "https://knsfenster.de/partners", hrefLang: "de" },
        { href: "https://kns-okna.eu/partners", hrefLang: "cs" },
        { href: "https://knsfinestre.it/partners", hrefLang: "it" },
        { href: "https://knsfenetres.fr/partners", hrefLang: "fr" },
        { href: "https://knsokna.eu/partners", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-24 text-center sm:px-6 lg:px-8 lg:py-32">
        {page?.content ? (<div>{parse(page.content)}</div>) : (<h1 className="font-bold text-3xl text-gray-400">Strona w budowie</h1>)}
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.PARTNERS[LOCALE as keyof typeof PAGE.PARTNERS] || 1;
    const { page } = await getPageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default Partners;

    async function __Next_Translate__getStaticProps__1a19cd2bee3__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/partners',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bee3__ as getStaticProps }
  